enum LOG_LINE_GRAVITY {
  INFO = "INFO",
  WARN = "WARN",
  ERROR = "ERROR",
}
export default LOG_LINE_GRAVITY;
